<template>
  <div class="Glossary Page__container">
    <div v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'Glossary',
  computed: {
    text() {
      return this.$store.getters['app/pages']['options/glossaire'][this.lang].text
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Glossary
  position relative

  p
    margin 0

  h2
    margin 40px 0

  h3
    color grad_blue1
    margin-top 20px
    margin-bottom 0px
</style>




// WEBPACK FOOTER //
// src/components/navigation/pages/Glossary.vue